(function () {
    'use strict';
    if(_.isFunction(_trackAnalytic))
    angular.module('Waiteraid').config(_trackAnalytic);
})();

